import SortIcon from "../../assets/images/SortIcon";
import StaffListDownloadIcon from "../../assets/images/StaffListDownloadIcon";
import { DashboardConstants } from "../../constants/constants";

const SortBar = () => {
  return (
    <div className="flex items-center pl-4 w-[117px] h-[40px] cursor-not-allowed staffListDownloadCheckbox text-primary border border-primary rounded-lg">
      {/* <div className="h-2 w-2 bg-sideMenuHelpBox rounded-full mr-2.5"></div> */}
      <SortIcon />
      <div className="pl-2.5">{DashboardConstants.sort}</div>
    </div>
  );
};
export default SortBar;
